<template>
  <div class="container">
    <ProductsList></ProductsList>
  </div>
</template>
<script>
import ProductsList from "@/components/FrontEnd/ProductsList.vue";

export default {
  components: {
    ProductsList,
  },
};
</script>
<style></style>
